import { useIsMobile } from '@/hooks/useIsMobile';
import O_CapsuleReactionsHeader from './O_CapsuleReactionsHeader';
import O_CapsuleReactionsHeaderMobile from './O_CapsuleReactionsHeaderMobile';
import { O_CapsuleReactionsHeaderProps } from './types';

export default function O_CapsuleReactionsHeaderResponsive(
  props: O_CapsuleReactionsHeaderProps
) {
  const isMobile = useIsMobile(1080);

  if (isMobile) {
    return <O_CapsuleReactionsHeaderMobile {...props} />;
  }

  return <O_CapsuleReactionsHeader {...props} />;
}
